import styled, {css} from 'styled-components';

import type {Size} from './types';

import {getColor, gts, ms} from '../../../../../styles';
import {Clickable} from '../../../../../uikit/Clickable';
import {Text} from '../../../../../uikit/Text';

export const Container = styled(Clickable)<{
  isSelected: boolean;
  size: Size;
  width?: number;
}>`
  display: flex;
  flex: 1;
  height: ${ms(36)};
  justify-content: center;
  align-items: center;
  border-radius: ${gts('borderRadius.sm')};
  background-color: ${p =>
    getColor(p.isSelected ? 'static.accent.trackers' : 'background.grayLight')};

  ${p =>
    p.width &&
    css`
      flex: 0 0 auto;
      width: ${ms(p.width)};
    `}

  ${p =>
    p.size === 'sm' &&
    css`
      height: ${ms(30)};
    `}
`;

export const Label = styled(Text).attrs({weight: 'semibold'})`
  text-transform: capitalize;
`;
